import React from "react"
import styles from "./SavingsRequiredForEdu.module.css"
import Image from "../Common/Image/Image"
import ParentChildImg from "../../assets/Calculator/ParentChild.png"
import ParentChildImg2x from "../../assets/Calculator/ParentChild@2x.png"

const SavingsRequiredForEdu = () => {
  return (
    <section className={styles.Container}>
      
      {/* Title */}
      <h2 className={styles.Title}>
        How much should you save for your child’s education? 
      </h2>

      {/* Description */}
      <p className={styles.Description}>
      When planning for your child's future education, it is important to account for factors   
like inflation. Education costs can rise over time.  
      </p>

      {/* Bottom Section */}
      <div className={styles.ContentWrapper}>
        
        {/* Left Card */}
        <div className={styles.LeftCard}>
          <p>
          For example, suppose your five-year-old child wants to become a lawyer. The approximate cost of pursuing a law degree today may be around <span className={styles.HighlightText}>₹8 lakh</span>. However, if your child is currently young and will begin college at age 21, the cost will increase due to inflation.
          <br/>
          <br/>
          Assuming an 8% annual inflation rate, <span className={styles.HighlightText}>₹8 lakh</span> today could grow to approximately <span className={styles.HighlightText}>₹27.41 lakh</span> by the year 2042. Hence, your investment plan should aim to accumulate <span className={styles.HighlightText}>₹27.41 lakh</span> by the time your child turns 21. If you start saving now and have 16 years to invest, and your investments generate an average return of 12% per annum, you would need to invest approximately <span className={styles.HighlightText}>₹6,974 per month</span> to reach this goal.
          <br/>
          <br/>
          Since every child’s goal and age may differ, you can use a child education calculator to estimate the required corpus and monthly investment based on the expected inflation rate and your needs.
          </p>
        </div>

        {/* Right Image */}
        <div className={styles.ImageWrapper}>
          <Image 
            src={ParentChildImg} 
            alt="Savings for Education" 
            lazy 
            srcSet={`${ParentChildImg} 1x, ${ParentChildImg2x} 2x`}
            className={styles.ParentChildImage}
          />
        </div>

      </div>
    </section>
  )
}

export default SavingsRequiredForEdu